export default __webpack_public_path__ + "static/media/dest.f2393d20.jpg";